import { ODataHeader, ODataString, ODataDecimal } from 'pbas-vue-components';
import { translate2 } from '../trans2';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const AdminFeesHeaders = [
  new ODataHeader({
    type: new ODataString('Id'),
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString('BillingTerm/Id'),
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString('BillingTerm/Name'),
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString('BillingTerm/Translations[]/LanguageCode'),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: 'headers.contributionterms.name',
    type: new ODataString('BillingTerm/Translations[]/Name', {
      getString: (item) => translate2(item.BillingTerm, 'Name'),
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: 'BillingTerm/Name',
  }),
  new ODataHeader({
    type: new ODataString('BillingTerm/Translations[]/RefId'),
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString('BillingTerm/Translations[]/Id'),
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),

  new ODataHeader({
    title: 'globals.amount',
    type: new ODataDecimal('Amount', {
      getString: (item) => {
        const value = item.Amount;
        if (value === null || value === undefined) {
          return '';
        }
        if (typeof value !== 'number') {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),

  new ODataHeader({
    title: 'headers.adjustments.PPTax',
    type: new ODataDecimal('PPTax', {
      getString: (item) => {
        const value = item.PPTax;
        if (value === null || value === undefined) {
          return '';
        }
        if (typeof value !== 'number') {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),

  new ODataHeader({
    title: 'headers.adjustments.PSTax',
    type: new ODataDecimal('PSTax', {
      getString: (item) => {
        const value = item.PSTax;
        if (value === null || value === undefined) {
          return '';
        }
        if (typeof value !== 'number') {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),

  new ODataHeader({
    title: 'headers.adjustments.RSTax',
    type: new ODataDecimal('RSTax', {
      getString: (item) => {
        const value = item.RSTax;
        if (value === null || value === undefined) {
          return '';
        }
        if (typeof value !== 'number') {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),

  new ODataHeader({
    title: 'headers.adminfees.QSTax',
    type: new ODataDecimal('QSTax', {
      getString: (item) => {
        const value = item.QSTax;
        if (value === null || value === undefined) {
          return '';
        }
        if (typeof value !== 'number') {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),

  new ODataHeader({
    title: 'headers.adjustments.GSTax',
    type: new ODataDecimal('GSTax', {
      getString: (item) => {
        const value = item.GSTax;
        if (value === null || value === undefined) {
          return '';
        }
        if (typeof value !== 'number') {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),

  new ODataHeader({
    title: 'headers.adjustments.HSTax',
    type: new ODataDecimal('HSTax', {
      getString: (item) => {
        const value = item.HSTax;
        if (value === null || value === undefined) {
          return '';
        }
        if (typeof value !== 'number') {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),

  new ODataHeader({
    title: 'headers.adjustments.total',
    type: new ODataDecimal('HSTax', {
      getString: (item) => {
        const value =
          item.Amount +
          item.PPTax +
          item.PSTax +
          item.RSTax +
          item.QSTax +
          item.GSTax +
          item.HSTax;
        if (value === null || value === undefined) {
          return '';
        }
        if (typeof value !== 'number') {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: false,
    visible: true,
    searchable: false,
  }),
];
export default AdminFeesHeaders;
